import { IconCheck as Check, IconGift as Gift } from "./icons";
import { APP_URL } from "@/lib/config";
import { DayHeading, DaySection, SlabButton } from "./day";
import { goToHero } from "./shared";

function Item({ children }: { children: string }) {
  return (
    <li className="flex gap-3">
      <span className="mt-0.5 grid size-5 shrink-0 place-items-center rounded-full bg-[#6B4EFF]">
        <Check className="size-3 text-white" />
      </span>
      <span className="font-semibold text-[#1C1A27]">{children}</span>
    </li>
  );
}

const card = "flex flex-col rounded-[22px] border-2 border-b-[6px] bg-white p-6 sm:p-8";

export function Pricing() {
  return (
    <DaySection id="pricing" label="Pricing" tone="tint">
      <DayHeading center eyebrow="Pricing" title="Start free. Try Pro before you pay." />
      <div className="mt-14 grid gap-5 lg:grid-cols-3">
        <div className={`${card} border-[#E7E3F0]`}>
          <p className="text-sm font-black tracking-[0.1em] text-[#8A8698] uppercase">Explore</p>
          <p className="mt-2 text-4xl font-black text-[#1C1A27]">Free</p>
          <p className="mt-2 text-[#6B6780]">Short lessons on whatever catches your eye.</p>
          <ul className="mt-6 space-y-3">
            <Item>Free lessons on anything in Explore</Item>
            <Item>Ask questions in any lesson</Item>
            <Item>A daily streak to keep you going</Item>
          </ul>
        </div>

        <div className={`${card} border-[#6B4EFF] border-b-[#4128B8]`}>
          <div className="flex items-center justify-between">
            <p className="text-sm font-black tracking-[0.1em] text-[#6B4EFF] uppercase">Pro</p>
            <span className="rounded-full bg-[#FFF1C7] px-3 py-1 text-xs font-black text-[#8A6100]">Free trial</span>
          </div>
          <p className="mt-2 text-4xl font-black text-[#1C1A27]">Your own courses</p>
          <p className="mt-2 text-[#6B6780]">Everything in Explore, plus courses built around your goal.</p>
          <ul className="mt-6 space-y-3">
            <Item>Courses made from your own words and goals</Item>
            <Item>The latest research, or your field’s official sources</Item>
            <Item>Citations on key claims, and sources you can choose</Item>
            <Item>A tutor that knows where you are</Item>
          </ul>
          <SlabButton onClick={goToHero} className="mt-8 self-start">Start free trial</SlabButton>
          <p className="mt-3 text-[13px] font-bold text-[#8A8698]">You’ll see the price before the trial starts. Cancel any time.</p>
        </div>

        <div className={`${card} border-[#E7E3F0]`}>
          <span className="grid size-11 place-items-center rounded-2xl border-b-[4px] border-[#C9931A] bg-[#FFC83D] text-[#5A3A00]">
            <Gift className="size-5" />
          </span>
          <p className="mt-4 text-2xl font-black text-[#1C1A27]">Give Pro to a friend</p>
          <p className="mt-2 leading-relaxed text-[#6B6780]">
            Know someone switching careers or deep in a side project? Give them a course built around where they’re going, not a catalogue.
          </p>
          <SlabButton href={APP_URL} quiet className="mt-auto self-start max-lg:mt-6">
            Gift Pro
          </SlabButton>
        </div>
      </div>
    </DaySection>
  );
}
